import RouterPage from './Pages/RouterPage';
import * as React from 'react'
import './App.css';
import './brand-theme.css';

function App() {
  return (
      <div className="App">
        <RouterPage />
      </div>
    );
}

export default App;
